import React from "react";
import styles from "./EditScreenImageTextPlacement.module.css";

const EditScreenImageTextPlacement = ({
  img,
  letteringPosition,
  width,
  height,
  letteringFont,
  letteringColor,
  letteringContent,
  uploadedImgSquare,
}) => {
  let textVertical = false;
  let gridArea = 0;
  if (letteringPosition === 1) {
    gridArea = "1 / 1 / 2 / 2";
  } else if (letteringPosition === 2) {
    gridArea = "1 / 2 / 2 / 3";
  } else if (letteringPosition === 3) {
    gridArea = "1 / 3 / 2 / 4";
  } else if (letteringPosition === 4) {
    gridArea = "2 / 1 / 3 / 2";
  } else if (letteringPosition === 5) {
    gridArea = "2 / 3 / 3 / 4";
  } else if (letteringPosition === 6) {
    gridArea = "3 / 1 / 4 / 2";
  } else if (letteringPosition === 7) {
    gridArea = "3 / 2 / 4 / 3";
  } else if (letteringPosition === 8) {
    gridArea = "3 / 3 / 4 / 4";
  }

  let fontFamily = `Noto Sans JP`;

  if (letteringFont === "1.クラシカル明朝体") {
    fontFamily = `athelas, serif`;
  } else if (letteringFont === "2.シンプルゴシック") {
    fontFamily = `futura-pt, sans-serif`;
  } else if (letteringFont === "3.手書きゴシック") {
    fontFamily = `amatic-sc, sans-serif`;
  } else if (letteringFont === "4.やわらか筆記体") {
    fontFamily = `learning-curve, sans-serif`;
  } else if (letteringFont === "5.クール筆記体") {
    fontFamily = `"Mathilde", cursive`;
  } else if (letteringFont === "6.丸め筆記体") {
    fontFamily = `Sacramento, cursive`;
  } else if (letteringFont === "7-1.レトロ明朝体・横書き") {
    fontFamily = `ten-mincho, serif`;
  } else if (letteringFont === "7-2.レトロ明朝体・縦書き") {
    fontFamily = `ten-mincho, serif`;
    textVertical = true;
  } else if (letteringFont === "8-1.丸ゴシック体・横書き") {
    fontFamily = `fot-tsukuardgothic-std, sans-serif`;
  } else if (letteringFont === "8-2.丸ゴシック体・縦書き") {
    textVertical = true;
    fontFamily = `fot-tsukuardgothic-std, sans-serif`;
  } else if (letteringFont === "9-1.手書きゴシック体・横書き") {
    fontFamily = `ta-kotodama-r, sans-serif`;
  } else if (letteringFont === "9-2.手書きゴシック体・縦書き") {
    textVertical = true;
    fontFamily = `ta-kotodama-r, sans-serif`;
  }

  let textColor = "";
  if (letteringColor === "1.グレー") {
    textColor = "gray";
  } else if (letteringColor === "2.ベージュ") {
    textColor = "beige";
  } else if (letteringColor === "3.白") {
    textColor = "white";
  } else if (letteringColor === "4.黒") {
    textColor = "black";
  }
  return (
    <div
      style={{ height: height + 50, width: width + 50 }}
      className={styles.edit_done_image_div}
    >
      <img
        style={{
          height: uploadedImgSquare ? "741px" : height + 50,
          width: uploadedImgSquare ? "621px" : width + 50,
          padding: uploadedImgSquare ? "0px" : "32px",
        }}
        className={styles.edited_done_image}
        src={img}
        alt="edited"
        crossOrigin="anonymous"
      />
      <div
        style={{
          height: height - 14,
          width: width - 14,
          marginLeft: 32,
          marginTop: 32,
        }}
        className={styles.grid_container}
      >
        <div
          className={`${styles.grid_item}`}
          style={{
            gridArea: gridArea,
          }}
        >
          <div
            id="test"
            style={{
              color: textColor,
              fontFamily: fontFamily,
              writingMode: textVertical ? "vertical-lr" : "horizontal-tb",
              msWritingMode: textVertical ? "vertical-lr" : "horizontal-tb",
              WebkitWritingMode: textVertical ? "vertical-lr" : "horizontal-tb",
              zIndex: "5",
            }}
            className={styles.text_center}
          >
            {letteringContent.split("\n").map((item, index) => {
              return <div key={index}>{item}</div>;
            })}
          </div>
        </div>
      </div>
      <div
        style={{
          height: height + 50,
          width: width + 50,
        }}
        className={styles.frame}
      ></div>
    </div>
  );
};
export default EditScreenImageTextPlacement;
